import { FC, ReactNode } from 'react';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    children: ReactNode;
    text?: string; // only for storybook
    className?: string;
}

const Heading4: FC<Props> = ({ children, text, className }) => {
    return <h4 className={cn('', className)}>{text ?? children}</h4>;
};
export default Heading4;
